import React from 'react';

export function SpinnerComponent(props: any) {
  return (
    <div
      className={`fullscreen d-flex justify-content-center align-items-center loadingSpinner ${
        !!props.hidePage ? 'hide-page' : ''
      }`}
    >
      <span className='spinner-border text-primary' role='status'>
        <span className='sr-only'>Loading...</span>
      </span>
    </div>
  );
}
